import script from "./segment-list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./segment-list-item.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__